import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { isEmailWalletConnector } from '@dynamic-labs/wallet-connector-core';
import { ProviderEnum } from '@dynamic-labs/sdk-api';
import { logger } from '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../../../utils/constants/colors.js';
import '../../../../shared/utils/classes/storage/localStorage.js';
import 'ethers';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/multi-wallet';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { Input } from '../../../../components/Input/Input.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import { getEmailProvider } from '../../../../data/api.js';
import '@dynamic-labs/rpc-providers';
import '../../../../utils/hooks/useWallets/utils/verifyMagicIsSetup/verifyMagicIsSetup.js';
import { useErrorContext } from '../../../../context/ErrorContext/ErrorContext.js';
import '../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../../components/IconButton/IconButton.js';
import { Button } from '../../../../components/Button/Button.js';
import '../../../../components/Alert/Alert.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../../../components/InlineWidget/InlineWidget.js';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import { useLoadingContext } from '../../../../context/LoadingContext/LoadingContext.js';
import { useEmailProvider } from '../../../../utils/hooks/useEmailProvider/useEmailProvider.js';

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const LoginWithEmailForm = () => {
    const { environmentId, wallets, projectSettings } = useInternalDynamicContext();
    const { loading, setLoading } = useLoadingContext();
    const { setErrorMessage } = useErrorContext();
    const [emailInput, setEmailInput] = useState('');
    const [emailError, setEmailError] = useState(false);
    const emailWalletConnector = wallets
        .map(({ walletConnector }) => walletConnector)
        .find(isEmailWalletConnector);
    const { handleEmailOnlyLoginSubmit, submitEmail, isEmailProviderLoading } = useEmailProvider({
        emailWalletConnector,
    });
    const isLoading = useMemo(() => isEmailProviderLoading || loading, [isEmailProviderLoading, loading]);
    const handleEmailOnChangeEvent = (event) => {
        const { value } = event.currentTarget;
        setEmailInput(value);
    };
    const isInjectedWalletProviderEnabled = emailWalletConnector !== undefined;
    const onChangeHandler = handleEmailOnChangeEvent;
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!EMAIL_REGEX.test(emailInput)) {
            setEmailError(true);
            return;
        }
        try {
            setLoading(true);
            if (isInjectedWalletProviderEnabled &&
                (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.confirmEmailProviderForVerify)) {
                // see: https://linear.app/dynamic-labs/issue/DYN-2517
                // if confirmWalletTransfers setting is true, check api first to confirm emailProvider
                const { emailProvider } = yield getEmailProvider({
                    email: emailInput,
                    environmentId,
                });
                if (emailProvider === ProviderEnum.EmailOnly) {
                    yield handleEmailOnlyLoginSubmit(emailInput);
                    return;
                }
            }
            yield submitEmail(emailInput);
        }
        catch (error) {
            logger.debug(error);
            setErrorMessage(error.code);
        }
        finally {
            setLoading(false);
        }
    });
    // social sign in currently coupled to email... might be better to decouple
    return (jsxs("form", Object.assign({ className: 'login-with-email-form', onSubmit: (e) => handleSubmit(e) }, { children: [jsx(Input, { id: 'email_field', value: emailInput, onChange: onChangeHandler, label: 'Enter your email', error: emailError, message: emailError && 'Please enter a valid email address' }), jsx(Button, Object.assign({ buttonClassName: 'login-with-email-form__button', type: 'submit', loading: isLoading, disabled: isLoading, buttonVariant: 'primary', buttonPadding: 'large', buttonRounded: 'medium', expanded: true }, { children: "Continue" }))] })));
};

export { EMAIL_REGEX, LoginWithEmailForm };
